import { Repeat, ScanLine, Search, X } from "lucide-react";
import { Button } from "../../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../ui/dialog";
import { DispoBackButton } from "./DispoBackButton";

/**
 * Jun-2026 (User-Wunsch) — Inzahlungnahme-Entscheidung.
 *
 * Drei farbige Buttons als Einstieg in den Eintausch-Workflow:
 *  - JA (grün)            → Eintausch erfassen, direkt zum ZB1-Scan.
 *  - Bereits angelegt (orange) → vorhandenes Fahrzeug per FIN/Nr. suchen.
 *  - NEIN (rot)           → keine Inzahlungnahme, weiter zu Zahlung & Rabatt.
 */
export function TradeInDecisionModal({ onBack, onClose, onYesScan, onAlreadyCreated, onNoPayment }) {
    return (
        <Dialog open onOpenChange={(o) => !o && onClose()}>
            <DialogContent onPointerDownOutside={(e) => e.preventDefault()} onInteractOutside={(e) => e.preventDefault()} className="max-w-lg" data-testid="dispo-modal-tradein-decision">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Repeat className="w-5 h-5 text-orange-600" /> Inzahlungnahme?
                    </DialogTitle>
                    <DialogDescription>Soll ein Eintausch-Fahrzeug angekauft werden?</DialogDescription>
                </DialogHeader>
                <p className="text-sm text-gray-600">
                    Nimmt der Kunde ein Fahrzeug in Zahlung? Wähle das passende Vorgehen.
                </p>
                <div className="grid grid-cols-1 gap-2.5 mt-1">
                    <Button type="button" onClick={onYesScan} data-testid="dispo-tradein-decision-yes"
                        className="w-full justify-start gap-3 h-auto py-3 px-4 rounded-sm bg-emerald-600 hover:bg-emerald-700 text-white text-left">
                        <ScanLine className="w-5 h-5 shrink-0" />
                        <span className="flex flex-col">
                            <span className="font-bold uppercase tracking-wider text-sm">Ja</span>
                            <span className="text-xs font-normal opacity-90">Eintausch erfassen — direkt zum ZB1-Scan</span>
                        </span>
                    </Button>
                    <Button type="button" onClick={onAlreadyCreated} data-testid="dispo-tradein-decision-existing"
                        className="w-full justify-start gap-3 h-auto py-3 px-4 rounded-sm bg-orange-500 hover:bg-orange-600 text-white text-left">
                        <Search className="w-5 h-5 shrink-0" />
                        <span className="flex flex-col">
                            <span className="font-bold uppercase tracking-wider text-sm">Bereits angelegt</span>
                            <span className="text-xs font-normal opacity-90">Vorhandenes Fahrzeug per FIN / Angebotsnr. suchen</span>
                        </span>
                    </Button>
                    <Button type="button" onClick={onNoPayment} data-testid="dispo-tradein-decision-no"
                        className="w-full justify-start gap-3 h-auto py-3 px-4 rounded-sm bg-red-600 hover:bg-red-700 text-white text-left">
                        <X className="w-5 h-5 shrink-0" />
                        <span className="flex flex-col">
                            <span className="font-bold uppercase tracking-wider text-sm">Nein</span>
                            <span className="text-xs font-normal opacity-90">Keine Inzahlungnahme — weiter zu Zahlung & Rabatt</span>
                        </span>
                    </Button>
                </div>
                {onBack && (
                    <DialogFooter>
                        <DispoBackButton onBack={onBack} />
                    </DialogFooter>
                )}
            </DialogContent>
        </Dialog>
    );
}
